/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */
import { Action, combineReducers, createFeatureSelector } from '@ngrx/store';

import { LOGIN_FEATURE_KEY, loginReducer, LoginState } from '@auth/store/reducers/auth.reducer';

export const AUTH_MODULE_KEY = 'auth';
export interface AuthModuleState {
  [LOGIN_FEATURE_KEY]: LoginState;
}

export function reducers(state: AuthModuleState | undefined, action: Action): any {
  return combineReducers({
    [LOGIN_FEATURE_KEY]: loginReducer,
  })(state, action);
}

export const getAuthModuleState = createFeatureSelector<AuthModuleState>(AUTH_MODULE_KEY);
